import React, { useCallback, useContext } from 'react';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';

import { uploadBatch } from '@actions/batch-actions';
import { openDashboardDialog } from '@actions/dashboard-actions';

import BatchContext from '@components/batch/batch-upload-edit/batch-context';
import { getEntityTypeConfig } from '@components/config/selectors';
import * as dialog from '@constants/dialogs';

import { getErrorsCount } from '@selectors/batch-edit-selector';

import DialogActions from '@shared/dialogs/dialog-actions';

import { convertBatchToFile, convertBatchToJSONFile } from '@utils/batch-utils';

const TopBarBatchUploadEditActions = () => {
  const dispatch = useDispatch();
  // sourceBatch is the converted batch (see saveBatch), batch the edited one.
  const { batch: sourceBatch, fileId } = useContext(BatchContext);
  const batch = useSelector(state => state.batchEdit[fileId]);
  const entityFields = useSelector(state => getEntityTypeConfig(state, batch?.entityType)?.config?.fields);
  const {
    map_category_type: categoryTypes,
    map_category: categories
  } = useSelector(state => state.dataTypes);
  const hasErrors = useSelector(state => getErrorsCount(state, fileId)) > 0;

  const onCancel = useCallback(
    () => {
      dispatch(push('/library/batch'));
    },
    [dispatch]
  );

  const onUpload = useCallback(
    () => {
      if (!batch) {
        return;
      }
      window.savingBatchUpload = true;
      const upload = {
        active: true,
        entityType: batch.entityType,
        status: 0
      };
      if (sourceBatch?.version === 2) {
        // v2 batches upload the edited batch data (JSON) instead of a CSV file.
        upload.file = convertBatchToJSONFile(batch, sourceBatch, entityFields);
        upload.version = 2;
      } else {
        upload.file = convertBatchToFile(batch, categoryTypes, categories, entityFields);
      }
      dispatch(uploadBatch(upload, null, null));
      dispatch(push({
        pathname: '/library/batch',
        state: { poll: true }
      }));
      window.savingBatchUpload = false;
    },
    [batch, categories, categoryTypes, dispatch, entityFields, sourceBatch]
  );

  const openUploadDialog = useCallback(
    () => dispatch(openDashboardDialog(dialog.UPLOAD_BATCH, { onUpload })),
    [dispatch, onUpload]
  );

  return (
    <DialogActions
      disabledSubmit={hasErrors}
      onCancel={onCancel}
      onSubmit={openUploadDialog}
      submitLabel="UPLOAD"
      submitTooltip={hasErrors ? 'Please fix all the errors before uploading.' : null}
    />
  );
};

export default TopBarBatchUploadEditActions;
